import { Check } from "lucide-react";
import { SectionHead } from "./SectionHead";

const CHANGES = [
  "精準曝光 21.6 萬次／月，效果等同一般曝光 432 萬次",
  "每月約 2,315 人對名人堂有潛在興趣",
  "客人自發分享（UGC）變 3 倍，曝光再多一倍",
  "公司團建詢問 2 倍以上，業績 +8%～25%",
  "訂房網站和 Google 搜尋帶來額外訂房",
  "官網多一個人客多專案頁，含 5 個房型專案",
];

const TOTALS = [
  { name: "保守", direct: "24–41 萬", spill: "82–111 萬", total: "約 NT$106–152 萬" },
  { name: "中等", direct: "41–70 萬", spill: "165–225 萬", total: "約 NT$206–294 萬" },
  { name: "樂觀", direct: "65–111 萬", spill: "280–392 萬", total: "約 NT$345–503 萬" },
];

const Totals = () => (
  <div className="mt-10 rounded-3xl bg-[var(--ink)] p-7 text-white md:p-10">
    <p className="text-sm font-black tracking-widest text-white/70">直接效應 + 外溢效益｜每月合計（與去年同期相比）</p>
    <p data-testid="grand-total-value" className="mt-2 text-4xl font-black md:text-6xl">約 NT$106–503 萬</p>
    <div className="mt-6 grid gap-4 md:grid-cols-3">
      {TOTALS.map((t) => (
        <div key={t.name} data-testid={`grand-total-${t.name}`} className="rounded-2xl bg-white/10 p-5">
          <p className="text-sm font-black text-white/70">{t.name}</p>
          <p className="mt-1 whitespace-nowrap text-2xl font-black">{t.total}</p>
          <p className="mt-2 text-sm"><span className="text-[var(--orange-2)]">直接 {t.direct}</span>＋<span className="text-[#47BBBC]">外溢 {t.spill}</span></p>
        </div>
      ))}
    </div>
  </div>
);

const Pricing = () => (
  <div data-testid="pricing" className="mt-10 rounded-3xl border-4 border-[var(--orange)] p-7 md:p-10">
    <p className="text-sm font-black tracking-widest text-[var(--orange)]">合作收費</p>
    <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-3 text-[var(--ink)]">
      <div><p className="text-sm font-bold text-[var(--text)]">前置投入</p><p data-testid="pricing-zero" className="text-6xl font-black text-[var(--orange)] md:text-7xl">0 元</p></div>
      <span className="text-4xl font-black text-[var(--orange-2)]">+</span>
      <p className="text-2xl font-black md:text-3xl">10 組網紅住房</p>
      <span className="text-4xl font-black text-[var(--orange-2)]">+</span>
      <a href="#pillars" className="text-2xl font-black underline decoration-[var(--orange-2)] underline-offset-8 md:text-3xl">上述配合</a>
      <span className="text-4xl font-black text-[var(--orange-2)]">+</span>
      <div><p className="text-sm font-bold text-[var(--text)]">成交抽成</p><p data-testid="pricing-commission" className="text-5xl font-black text-[var(--orange)] md:text-6xl">25%</p></div>
    </div>
    <div data-testid="pricing-commission-note" className="mt-6 rounded-2xl bg-[var(--warm)] p-5">
      <p className="font-black text-[var(--ink)]">25% 抽成只算「直接效應」的成交</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {["LINE@ 成交", "人客多專案成交", "電話訂房專案成交"].map((t) => <span key={t} className="action-tag">{t}</span>)}
      </div>
      <p className="mt-3 text-sm text-[var(--text)]">團建、訂房網站、Google 等外溢效益，不抽成。</p>
    </div>
  </div>
);

export const Conclusion = () => (
  <section id="conclusion" data-testid="conclusion-section" className="mx-auto max-w-6xl px-5 py-20">
    <SectionHead no="07" title="結論" sub="名人堂會有這些改變，前置投入 0 元" />
    <ul className="mt-8 grid gap-3 md:grid-cols-2">
      {CHANGES.map((c, i) => (
        <li key={c} data-testid={`change-${i}`} className="flex items-start gap-3 rounded-2xl bg-[var(--warm)] p-4 font-bold text-[var(--ink)]">
          <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-[var(--orange)] text-white"><Check size={14} /></span>{c}
        </li>
      ))}
    </ul>
    <Totals />
    <Pricing />
  </section>
);
